import { render, staticRenderFns } from "./RubricPresetView.vue?vue&type=template&id=70ba1042&scoped=true"
import script from "./RubricPresetView.vue?vue&type=script&lang=js"
export * from "./RubricPresetView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ba1042",
  null
  
)

export default component.exports